<template>
  <div style="clear: both;">
    <v-overlay v-model="loading" class="align-center justify-center">
      <v-card dark width="300">
        <v-card-text>
          {{ $t('Loading') }}
          <v-progress-linear indeterminate color="light-green-darken-4" striped height="10" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-form>
      <v-card class="result-content">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <v-row dense class="align-center">
              <v-col>
                <span>Archived MOC</span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
        <v-container fluid>
          <v-row dense v-if="results.length === 0">
            <p>{{ $t('No_Results') }} for {{ mocId }}</p>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12" v-for="result in results" :key="result.id">
              <p>
                <ArchiveButton
                  :ref="`archiveButton-${result.id}`"
                  :mocId="result.id"
                  v-if="isClosedStatus(result.status)"
                  :isEmoc1Archive="true"
                />
                <a v-if="!isEmoc1Id(result.id)" class="link" :href="getMocUrl(result.id)"
                  ><strong>{{ result.id }}</strong> - {{ result.community }} - {{ result.title || '' }}</a
                >

                <!-- Emoc1 -->
                <a v-else class="link" href="#" @click.prevent="downloadEmoc1(result.id)"
                  ><strong>{{ result.id }}</strong> - {{ result.community }} - {{ result.title || '' }}</a
                >
              </p>
              <p>{{ $t('Status') }}: {{ result.status }}</p>
              <p>
                <span>{{ result.description }}</span>
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import MOCService from '@/services/moc.service'
import Toaster from '@/components/Toaster'
import { FormStatus } from '@/common'
import ArchiveButton from '@/components/archive/ArchiveButton'

export default {
  name: 'Archive',
  components: {
    Toaster,
    ArchiveButton
  },
  data() {
    return {
      loading: false,
      showResults: false,
      results: [],
      mocId: null
    }
  },
  methods: {
    isEmoc1Id(mocId) {
      return mocId.toLowerCase().startsWith('emoc-')
    },
    isClosedStatus(status) {
      const statusName = status.toLowerCase()
      switch (statusName) {
        case FormStatus.properties[FormStatus.CLOSED].name.toLowerCase():
        case FormStatus.properties[FormStatus.CLOSEDREJECTED].name.toLowerCase():
        case FormStatus.properties[FormStatus.CLOSEDVOIDED].name.toLowerCase():
        case FormStatus.properties[FormStatus.CLOSEDSTRANDED].name.toLowerCase():
          return true
        default:
          return false
      }
    },
    search(mocId) {
      this.loading = true
      this.mocId = mocId
      MOCService.search(mocId, 1, 1, null)
        .then(response => {
          console.log(response.results)
          if (!response.results.length) {
            this.$refs.toaster.pop('info', this.$t('No_Results'))
            this.query = ''
            this.$emit('onClose')
            return
          }
          if (response.results[0].id.toUpperCase() !== mocId.toUpperCase()) {
            this.$refs.toaster.pop('info', this.$t('No_Results'))
            this.query = ''
            this.$emit('onClose')
            return
          }
          this.showResults = true
          this.results = response.results
        })
        .catch(e => {
          this.$refs.toaster.pop('error', this.$t('Error_Search'))
        })
        .finally(() => (this.loading = false))
    }
  },
  async created() {
    if (this.$route.params.id) {
      let regex = /(EMOC)-[a-zA-Z_]{3}-\d{8}/g
      if (this.$route.params.id.match(regex)) {
        this.search(this.$route.params.id)
      } else {
        //this.$refs.toaster.pop('MocId is not valid', this.$route.params.id)
      }
    }
  }
}
</script>

<style scoped>
.result-content a {
  color: #0000ee !important;
}
</style>
